module.exports = __webpack_public_path__ + "static/media/star.d99ef3cb.svg";